export const NEXUS_MUTUAL_COOKIE_CONSENT = 'nexus-mutual-cookie-consent';
